import { SgVehicleLookupUtil } from 'saga-modules';
import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

function lookupVehicleInfoBasedOnVin(vin, additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupBasedOnVIN',
        [vin],
        additionalHeaders
    );
}

function lookupVehicleInfoBasedOnRegistration(reg, additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupBasedOnRegistration',
        [reg],
        additionalHeaders
    );
}

function lookupMakes(additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupMakes',
        [],
        additionalHeaders
    ).then((result) => {
        const allMakes = result.makes.map((make) => ({
            code: make,
            name: make
        }));
        return SgVehicleLookupUtil.extractTopMakes(allMakes);
    });
}

function lookupModels(make, additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupModels',
        [make],
        additionalHeaders
    ).then((result) => {
        return result.models.map((model) => ({
            code: model,
            name: model
        }));
    });
}

function lookupYears(make, model, additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupYears',
        [make, model],
        additionalHeaders
    ).then((result) => {
        return result.years.map((year) => ({
            code: year.toString(),
            name: year.toString()
        }));
    });
}

function autofillBasedOnPartialDto(dto, additionalHeaders = {}) {
    return JsonRPCService.send(
        getProxiedServiceUrl('vehicleInfoLookup'),
        'lookupBasedOnPartialDTO',
        [dto],
        additionalHeaders
    );
}

export default {
    lookupVehicleInfoBasedOnVin,
    lookupVehicleInfoBasedOnRegistration,
    lookupMakes,
    lookupModels,
    lookupYears,
    autofillBasedOnPartialDto
};
